import { render, staticRenderFns } from "./MakeInfo.vue?vue&type=template&id=6dbd3dea"
import script from "./MakeInfo.vue?vue&type=script&lang=js"
export * from "./MakeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports